import { FlowType } from "./flow-type";
import { StepModel } from "./step.model";

// Mapa de passos visuais do wizard ----------------------------------------

export const TOPIC_STEPS = ["Paciente", "Definições", "Ativos", "Veículo", "Dose"] as const;
export const ORAL_STEPS = ["Paciente", "Definições", "Ativos", "Dose"] as const;

/**
 * Retorna o índice visual do passo ativo no stepper.
 * ACTIVES, SUBCLASS e PRODUCTS são todos o dot "Ativos" (índice 2 no tópico).
 */
export function stepToIndex(step: StepModel, flowType: FlowType): number {
    switch (step) {
        case StepModel.PATIENT:
            return 0;
        case StepModel.DEFINITIONS:
            return 1;
        case StepModel.DEFINITIONS_ORAL:
            return 1;
        case StepModel.ACTIVES:
        case StepModel.SUBCLASS:
        case StepModel.PRODUCTS:
        case StepModel.ACTIVES_ORAL:
            return 2;
        case StepModel.VEHICLES:
            return flowType === 'oral' || flowType === 'ORAL' ? 2 : 3;
        case StepModel.DOSAGE:
        case StepModel.DOSAGE_ORAL:
            return flowType === 'oral' || flowType === 'ORAL' ? 3 : 4;
        default:
            return 0;
    }
}
